const LOCATION_TYPE_CATEGORY_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default LOCATION_TYPE_CATEGORY_INITIAL_STATE
